import { useEffect, useState } from 'react'
import { useForm, useFieldArray } from 'react-hook-form'
import { useWindowSize } from 'react-use'
import { difference, flatten } from 'lodash-es'
import Ditto from '../ditto/register.filter'

const filterableFieldTypes = Ditto.fields

const unfilterableSlugs = ['isDeleted', 'lnglat', 'isActived']
// 判空类型，需要特殊处理
const specialType = ['judgeNull']
// 特殊的筛选类型，需要特殊处理
const specialQueryType = ['isNull', 'notNull']
// 多选
const multipleType = ['containedByArray', 'inList']

const mergeOtherFields = function (allFields, filters, tbs) {
  const otherTbFields = []
  ;(filters.queries || []).forEach((item) => {
    if (item.tbId) {
      const otherFields = tbs[item.tbId].fields
      otherTbFields.push(otherFields.find((f) => f.slug === item.slug))
    }
  })
  return Object.assign(allFields, otherTbFields)
}

const getFilterableFields = function (allFields) {
  return allFields
    .filter((f) => {
      return (
        filterableFieldTypes.includes(f.type) &&
        !unfilterableSlugs.includes(f.slug)
      )
    })
    .map((f) => {
      return {
        ...f,
        value: f.slug,
      }
    })
}

const getField = function (slug, filterableFields = []) {
  // for (let i = 0; i < filterableFields.length; i++) {
  //   const ff = filterableFields[i]
  //   if (ff.slug === slug) {
  //     return ff
  //   }
  // }
  // return null

  return filterableFields.find((v) => v.slug === slug) || null
}

const getProductQueries = function (fields, filters) {
  const { queries = [] } = filters
  const arr = [...queries]
  return arr
    .map((v) => {
      const obj = fields.find((f) => f.slug === v.slug && f.type === 'product')
      if (obj) {
        return { ...v, slugs: obj.productSlugs }
      }
      return null
    })
    .filter((v) => v)
}

const getFieldsMap = function (fields) {
  if (!fields) {
    return {}
  }
  const FieldsMap = {}
  fields.forEach((field) => {
    // eslint-disable-next-line no-unused-expressions
    field.slug && (FieldsMap[field.slug] = field)
  })
  return FieldsMap
}

// viewConfig_filters
export default (
  allFields,
  fixedSlug,
  filters = {},
  currentFilters = {},
  tbs = [],
  fixedSlugNum = 5
) => {
  const { width } = useWindowSize()
  const isMiddle = width <= 768
  // 合并其他表单的表定义
  const mergeFields = mergeOtherFields(allFields, filters, tbs)
  // 这里用来获取可以被筛选的字段
  const filterableFields = getFilterableFields(mergeFields)
  // 整合字段
  const productQueries = getProductQueries(allFields, filters)
  // TODO: memod
  const fieldsMap = getFieldsMap(mergeFields)

  // 固定筛选数据 与所有筛选数据处理
  const handleQueries = (filterQueries = [], defaultQueries = []) => {
    return filterQueries.map((fixedItem) => {
      const sameItem = defaultQueries.find((v) => fixedItem.slug === v.slug)
      // 需保证queryType一致
      if (sameItem && fixedItem.queryTypes.includes(sameItem.queryType)) {
        return { ...sameItem, ...fixedItem, value: sameItem.value }
      }
      return {
        ...fixedItem,
        value: '',
      }
    })
  }

  // 将所有筛选项通过【优先展示筛选项列表】进行排序
  const getDefaultValuesBySort = (queries) => {
    if (!fixedSlug.length) return queries

    const arr = fixedSlug.map((slug) => {
      return queries.find((query) => {
        return query.slug === slug
      })
    })
    queries.forEach((item) => {
      if (!fixedSlug.includes(item.slug)) arr.push(item)
    })
    return arr
  }

  const defaultValues = {
    logicType: filters.logicType || 'and',
    // queries: filters.queries || [],
    queries: getDefaultValuesBySort(
      handleQueries(filters.queries, currentFilters.queries) || []
    ),
  }

  const { control, getValues, watch, setValue, reset } = useForm({
    defaultValues,
  })

  const {
    fields: allFilters,
    append,
    remove,
    update,
  } = useFieldArray({
    control,
    name: 'queries',
  })
  // 获取优先显示的筛选项
  const getFixedShowFilters = () => {
    const showFilterNum = isMiddle ? 1 : fixedSlugNum
    const arr = fixedSlug.map((slug) => {
      return allFilters.find((filter) => filter.slug === slug)
    })
    if (arr.length >= showFilterNum) return arr
    allFilters.forEach((item) => {
      if (arr.length < showFilterNum && !fixedSlug.includes(item.slug)) {
        arr.push(item)
      }
    })
    return arr
  }

  // 将来如果是锁定视图, 就 reset 成 filters
  const resetQueries = () => {
    setValue('queries', [])
  }

  const addQuery = () => {
    append({})
  }

  const removeQuery = (index) => {
    remove(index)
  }

  // 将输入的所有内容清空(不清空组件)
  const resetFilters = () => {
    const queries = getValues('queries') || []
    reset()
    setValue('logicType', defaultValues.logicType)
    queries.forEach((q, index) => {
      setValue(`queries.${index}.value`, '')
    })
    const fixedSlugs = queries.map((v) => v.slug)
    const fixedProductSlugs = flatten(productQueries.map((v) => v.slugs))
    const defaultSlugs = (currentFilters.queries || []).map((v) => v.slug)
    const slugs = difference(defaultSlugs, [
      ...fixedSlugs,
      ...fixedProductSlugs,
    ])

    return {
      logicType: getValues().logicType,
      queries: (currentFilters.queries || []).filter((v) =>
        slugs.includes(v.slug)
      ),
    }
    // const defaultSlugs = (currentFilters.queries || []).map((v) => v.slug)
    // const slugs = defaultSlugs
    // const queries = getValues('queries') || []
    // queries.forEach((q, index) => {
    //   if (!slugs.includes(q.slug)) {
    //     setValue(`queries.${index}.value`, '')
    //   } else {
    //     setValue(
    //       `queries.${index}.value`,
    //       currentFilters.queries.find((f) => f.slug === q.slug).value
    //     )
    //   }
    // })

    // // const fixedSlugs = queries.map((v) => v.slug)
    // // const slugs = difference(defaultSlugs, fixedSlugs)

    // return {
    //   logicType: getValues().logicType,
    //   queries: (currentFilters.queries || []).filter((v) =>
    //     slugs.includes(v.slug)
    //   ),
    // }
  }

  // 这里用来判断某个字段都有哪种筛选类型
  // SDH_TODO: 你看看这儿, 这儿是用来处理那个筛选的类型的
  const getCurrentQuery = (index) => {
    const q = watch('queries')[index]
    console.log('[useFilters:filters-data]', q)
    if (!q || !q.slug) {
      return []
    }
    let { slug } = q
    if (Array.isArray(q.slug)) {
      ;[slug] = slug
    }
    const field = getField(slug, filterableFields)
    if (!field) {
      return {
        queryTypes: [],
      }
    }
    // 首先从视图配置中获取type，如果没有设置type，则从表单定义中获取
    const query = Ditto.filter((q.opts && q.opts.type) || field.type)

    const _queryType =
      q.queryType && q.queryType.length > 0 ? q.queryType[0] : q.queryType

    const opts = {
      multiple: multipleType.includes(_queryType),
    }

    if (field.type === 'standard') {
      opts.lastStage = false
    }

    const _field = { ...field, ...opts }

    return {
      queryTypes: query.queryTypes,
      queryType: q.queryType,
      slug,
      field: _field,
      value: q.value,
      lock: q.lock,
    }
  }

  const onChangeField = (index, e) => {
    update(index, e)
  }

  // 这个没有用到？？
  const onChangeQueryType = (index, e, onChange, type) => {
    const beforeType = (
      getValues(`queries.${index}.queryType`) || ''
    ).toString()
    const selectType = (e || '').toString()
    if (beforeType !== selectType && type !== 'boolean') {
      setValue(`queries.${index}.value`, null)
    }
    if (type === 'boolean') {
      if (e && e[0]) {
        setValue(`queries.${index}.value`, true)
      } else {
        setValue(`queries.${index}.value`, false)
      }
    }
    onChange(e)
  }

  const commitFilters = () => {
    const cf = getValues()
    console.log('commitFilters:filters-data', cf)
    // 默认筛选的slug
    const currentQueries = currentFilters
      ? currentFilters.queries.map((m) => m.slug)
      : []
    let productsQueris = []
    const otherQueries = cf.queries
      .map((x) => {
        const ret = {
          ...x,
          queryType: x.queryType || (x.queryTypes && x.queryTypes[0]),
          fixed: true,
        }
        if (Array.isArray(x.slug)) {
          // eslint-disable-next-line prefer-destructuring
          ret.slug = x.slug[0]
        }
        // 筛选去除项时要将queryType为isNull || notNull 忽略掉
        // 筛选去除项时要将 固定筛选、默认筛选重复的字段 忽略掉
        if (
          !(x.value || x.value === false || x.value === 0) &&
          !specialQueryType.includes(x.queryType) &&
          !currentQueries.includes(x.slug)
        ) {
          // 去除项
          ret.remove = true
        }

        if (!x.value && currentQueries.includes(x.slug)) {
          ret.resume = true // 恢复默认值
        }

        // 处理整合字段筛选
        if (x.slug === 'route') {
          const { value: selectValue } = x

          productsQueris = (selectValue || []).map((s) => {
            if (s.value) {
              return { ...ret, ...s }
            }
            return { ...ret, ...s, remove: true }
          })
        }

        return ret
      })
      .filter((x) => {
        return x.slug && x.queryType
      })

    const queries = [...otherQueries, ...productsQueris]

    // 需要转换的query
    const transformerQueries = queries.map((query) => {
      const { opts, queryType, tbId } = query
      const type = opts && opts.type
      // 是否为判空组件
      const isJudgeNull = specialType.includes(type)
      // 筛选类型是否为【isNull】【notNull】
      const isSpecialQueryType = specialQueryType.includes(queryType)
      return {
        ...query,
        // 1. 如果当前筛选项为判空组件，value值需为null，queryType需为isNull || notNull
        // 2. 或者当前筛选类型为isNull || notNull
        value: isJudgeNull || isSpecialQueryType ? null : query.value,
        queryType: isJudgeNull ? query.value : query.queryType,
        tbId,
      }
    })

    const obj = {
      logicType: cf.logicType,
      queries: transformerQueries,
    }
    return obj
  }

  /**
   * 当前筛选组件是否需要设置为disabled
   * @param {*} currentQueryType
   * @returns
   */
  const fieldIsDisabled = (currentQueryType) => {
    return specialQueryType.includes(currentQueryType)
  }

  // 标识是否展开固定筛选
  const isNeedExpand = (priorityShowFilters) => {
    return allFilters.length > priorityShowFilters.length
  }
  // 标识是否展开了固定筛选
  const [isExpand, setIsExpand] = useState(false)
  const [fixedShowFilters, setFixedShowFilters] = useState([])
  useEffect(() => {
    setValue('logicType', defaultValues.logicType)
    setValue('queries', defaultValues.queries)
    // setIsExpand(false)
  }, [filters, currentFilters])

  useEffect(() => {
    setFixedShowFilters(getFixedShowFilters())
  }, [allFilters, width])

  return {
    // 数据
    // uncommitedFilters,
    // logicType,
    fieldsMap,
    allFilters, // 所有的筛选项
    fixedShowFilters, // 优先显示的筛选项
    isNeedExpand,
    isExpand,
    setIsExpand,
    filterableFields,
    // allFields,
    // queriesData,
    control,
    setValue,
    fieldIsDisabled,
    watch,
    // 操作
    resetQueries,
    resetFilters,
    addQuery,
    removeQuery,
    // setLogicType,
    getCurrentQuery,
    // setCollector,
    commitFilters,
    onChangeField,
    onChangeQueryType,
  }
}
